import { call, put, takeLatest } from 'redux-saga/effects';

import { getPropertyObjects, getFilteredPropertyObjects } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

export function* getData(action) {
  const response = yield call(
    action.type === actionTypes.FILTERED_REQUEST_START
      ? getFilteredPropertyObjects
      : getPropertyObjects,
    action.payload,
  );
  //попробовать добавить метод по условию

  if (response.isOk) {
    yield put(requestSuccess(response.data));
  } else {
    yield put(requestFailure(response.error));
  }
}

export default function* propertyObjectsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.FILTERED_REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
